import {Component, Input} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component(
    {
        selector: 'app-ngbd-modal-content',
        template: `
            <div class="modal-header">
                <h4 class="modal-title">Confirmación </h4>
                <button type="button" class="close" aria-label="Close" [disabled]="loading" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                ¿ Está seguro que quiere subir el archivo
                <span class="font-weight-bold">{{message}}</span> ?
            </div>
            <div class="modal-footer">
                <div>
                    <button type="button" class="btn btn-danger" [disabled]="loading" (click)="activeModal.close('Close click')">Cancelar
                    </button>
                    <button type="button" class="btn btn-primary ml-2" [ladda]="loading"  (click)="activeModal.close('confirm')">Aceptar</button>
                </div>
            </div>
        `
    }
)

export class ConfirmFileModalComponent {
    @Input() message;
    loading = false;

    constructor(public activeModal: NgbActiveModal) {
    }


}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/upload-awards/modal/confirm-file-modal-component.ts